//import {
//	UploadBoxError,
//	useUploadBox,
//} from '@ui/components/upload-box/upload-box.hooks.ts'

//import './upload-box.scss'
import clsx from 'clsx'
import { type MobileState } from '@store/mobile-reducer.ts'
import { forwardRef, useMemo, useRef } from 'react'
import { useUploadBox, type UploadBoxError } from './upload-box.hooks'

const DeleteComponent: React.FC<{
	onClick: () => void
	show?: boolean
}> = ({ onClick, show = true }) => {
	if (show) {
		return (
			<div className={'upload-box__attach'} onClick={onClick}>
				<img
					src={'/assets/images/Cestino.svg'}
					className={'upload-box__trash'}
					alt={'trash'}
				/>
			</div>
		)
	}

	return null
}

type AttachmentComponentProps = {
	onChange: (files: FileList | null) => void
	title: string
	show?: boolean
	className?: string
}
const AttachmentComponent: React.FC<AttachmentComponentProps> = ({
	onChange,
	title,
	show,
	className,
}) => {
	if (show) {
		return (
			<div className={'upload-box__attach'}>
				<p>Allega documento</p>
				<input
					type={'file'}
					className={className}
					name={title}
					id={title}
					onChange={(e) => onChange(e.target.files)}
				/>
			</div>
		)
	}

	return null
}

type UploadComponent = Exclude<
	AttachmentComponentProps,
	'show' | 'className'
> & {
	hasBeenUploaded: boolean
	file?: File | null
	error: UploadBoxError | null
	id: number
}
const UploadComponent = forwardRef<HTMLInputElement, UploadComponent>(
	(props, ref) => {
		const { title, onChange, hasBeenUploaded, error } = props
		const imageSource = useMemo(
			() => (hasBeenUploaded ? '' : '/assets/images/Fotocamera.svg'),
			[hasBeenUploaded]
		)

		const showPreview = () => {
			if (hasBeenUploaded && props.file) {
				const url = window.URL.createObjectURL(props.file)
				window.open(url, '_blank')
			}
		}

		return (
			<div
				className={clsx('upload-box__container', {
					'upload-box__container--border': !hasBeenUploaded,
					'upload-box__container--border-success': hasBeenUploaded,
					'upload-box__container--error': !!error,
				})}
				onClick={showPreview}
			>
				<div className={'upload-box__icon'}>
					<img
						src={imageSource}
						alt={'fotocamera'}
						className={clsx({
							hidden: !!error || hasBeenUploaded,
						})}
					/>
					<div
						className={clsx('upload-box__icon-success', {
							hidden: !hasBeenUploaded,
						})}
					>
						<img
							src={'/assets/images/upload-success.svg'}
							alt={'documento caricato con successo'}
						/>
						<p className={''}>File {props.id}</p>
					</div>
					<p
						className={clsx({
							hidden: !error,
						})}
					>
						<img
							src={'/assets/images/denied.svg'}
							alt={'errore di caricamento'}
						/>
					</p>
					<p
						className={clsx('upload-box__label', {
							hidden: !!error || hasBeenUploaded,
						})}
					>
						Fotografa documento
					</p>
				</div>
				{!hasBeenUploaded && (
					<input
						type={'file'}
						ref={ref}
						className={'upload-box__inpt'}
						name={title}
						id={title}
						onChange={(e) => onChange(e.target.files)}
					/>
				)}
			</div>
		)
	}
)

const ErrorComponent: React.FC<{ show?: boolean; message: string }> = ({
	show = false,
	message,
}) => {
	if (show) {
		return (
			<section className='upload-box__error'>
				<p>{message}</p>
			</section>
		)
	}

	return null
}

type UploadBoxSuccess = (id: string, file: File) => void
type UploadBoxComponentProps = {
	id: keyof MobileState['steps']
	side: string
	onSuccess: UploadBoxSuccess
	onDelete: (id: string) => void
	showID?: boolean
	index: number
}
const UploadBox: React.FC<UploadBoxComponentProps> = ({
	id,
	side,
	onSuccess,
	onDelete,
	showID = true,
	index,
}) => {
	const {
		actions: { uploadFiles, deletePhoto },
		data: { error, file },
	} = useUploadBox(id, side, onSuccess, onDelete)
	const title = `${side.at(0)?.toUpperCase()}${side.slice(1, side.length)}`
	const ref = useRef<HTMLInputElement>(null)

	return (
		<div className={'upload-box'}>
			{showID && <p>{title}</p>}
			<UploadComponent
				onChange={uploadFiles}
				title={title}
				ref={ref}
				file={file}
				hasBeenUploaded={!!file}
				error={error}
				id={index}
			/>
			<DeleteComponent onClick={deletePhoto} show={!!file} />
			<AttachmentComponent
				onChange={uploadFiles}
				className={'upload-box__attach-inpt'}
				title={title}
				show={!file && !error}
			/>
			<ErrorComponent message={error?.description ?? ''} show={!!error} />
		</div>
	)
}

export { UploadBox, type UploadBoxSuccess }
